export const pageStyle = `
        @page { 
            size: auto, 
            padding: 0 , 
            margin-top: 0.3rem, 
            margin-bottom: 0.3rem,
            font-size: 0.9rem; 
        }
        .patient-education-content__header {
            font-family: inherit;
            font-size: 2.5rem !important;
            color: black !important;
        }
        .patient-education-content__links {
            display: none !important;
        }
        .back-button {
            display: none !important;
        }
        .patient-education-content__description {
            margin-top: 0 !important;
        }
        .patient-education-content__copy-link-toast {
            display: none !important;
        }
        @fonts{
            family: inherit;
            size: 0.9rem;
        }
        .print-only {
            display: block !important;
            margin-bottom: 1rem;
            
        }
        .hide-from-print{
            display: none;
        }
        '@media print': {
            display: 'block'
        },
    `;
